<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="searchDialog" persistent max-width="700px" width="700px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="searchDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>انشاء تقرير</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <div style="margin-top: 20px"></div>
          <v-row>
            <v-col cols="6">
              <v-autocomplete v-model="typeId" :items="reportType" item-text="name" item-value="id" outlined label="نوع التقرير"></v-autocomplete>
              <v-autocomplete v-model="boxId" v-if="typeId == 2" :items="expensesSecondOptions" item-text="name" item-value="id" outlined label="الصندوق"></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-dialog ref="dialog" v-model="datePickerSearchModel" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="dateRangeText" label="اختر التاريخ من - الى" readonly outlined v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="dates" scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="datePickerSearchModel = false"> الغاء </v-btn>
                  <v-btn text color="primary" @click="getDates"> موافق </v-btn>
                </v-date-picker>
              </v-dialog>
              <v-autocomplete v-model="expensesTypeId" v-if="typeId == 2" :items="expensesTypes" item-text="typeName" item-value="idExpensesType" outlined label="التبويب"></v-autocomplete>
            </v-col>
          </v-row>
          <v-textarea v-model="content" v-if="typeId == 2" outlined color="primary" label="تحتوي على" :rules="studentRequiredFormRules"></v-textarea>
          <v-autocomplete v-model="receiptBoxId" v-if="typeId == 1" :items="receiptSecondOPtions" item-text="name" item-value="id" outlined label="الصندوق"></v-autocomplete>
          <!-- <v-autocomplete v-model="receiptTypeId" v-if="typeId == 1" :items="receiptTypes" item-text="typeName" item-value="idReceiptType" outlined label="التبويب"></v-autocomplete> -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="searchData" v-on:keyup.enter="searchData"> بحث </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mx-2" fab small color="primary" @click="searchDialog = true" v-bind="attrs" v-on="on">
          <v-icon> mdi-magnify </v-icon>
        </v-btn>
      </template>
      <span>بحث</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    expensesTypes: Array,
    receiptTypes: Array,
  },
  data: () => ({
    searchDialog: false,
    typeId: "",
    expensesTypeId: "",
    boxId: "",
    receiptBoxId: "",
    content: "",
    receiptTypeId: "",
    studentRequiredFormRules: [(v) => !!v || "حقل مطلوب . يرجى ادخال قيمة"],
    datePickerSearchModel: false,
    reportType: [
      { name: "ايرادات", id: 1 },
      { name: "مصروفات", id: 2 },
      { name: "التقرير اليومي للصناديق للمراحل", id: 3 },
      { name: "التقرير اليومي للصناديق الاول", id: 4 },
      { name: "التقرير اليومي لصندوق التأييدات", id: 5 },
      { name: "التقرير اليومي لصندوق التعليم المستمر", id: 6 },
      { name: "التقرير اليومي لصندوق الرواتب", id: 7 },
    ],
    receiptSecondOPtions: [
      { name: "الجميع", id: 999 },
      { name: "الصندوق الرئيسي", id: 1 },
      { name: "صندوق الهويات", id: 2 },
      { name: "صندوق الاستمارات", id: 7 },
      { name: "صندوق هويات حجز مقعد", id: 9 },
      { name: "صندوق اقساط حجز مقعد", id: 10 },
      { name: "صندوق الخدمات الجامعية", id: 11 },
      { name: "صندوق مؤسسة اللجين الخيرية", id: 12 },
      { name: "صندوق التدريب الصيفي", id: 13 },
      { name: "صندوق المركز الطبي", id: 14 },
      { name: "صندوق اقساط المرحلة الاولى", id: 15 },
      { name: "صندوق هويات المرحلة الاولى", id: 16 },
      { name: "صندوق خدمات المرحلة الاولى", id: 18 },
      { name: "صندوق التأييدات", id: 4 },
      { name: "صندوق طب الاسنان", id: 21 },
      { name: "صندوق التعليم المستمر", id: 22 },
      { name: "صندوق الرواتب", id: 25 },
      { name: "صندوق دفعة اولى ٢٠٢٦-٢٠٢٧", id: 26 },
      { name: "صندوق السنوات السابقة", id: 5 },
    ],
    expensesSecondOptions: [
      { name: "الجميع", id: 999 },
      { name: "الصندوق الرئيسي", id: 1 },
      { name: "الصندوق الرئيسي عدا الهويات", id: 3 },
      { name: "صندوق التأييدات", id: 4 },
      { name: "صندوق الاستمارات", id: 7 },
      { name: "صندوق الهويات", id: 2 },
      { name: "صندوق هويات حجز مقعد", id: 9 },
      { name: "صندوق اقساط حجز مقعد", id: 10 },
      { name: "صندوق الخدمات الجامعية", id: 11 },
      { name: "صندوق مؤسسة اللجين الخيرية", id: 12 },
      { name: "صندوق التدريب الصيفي", id: 13 },
      { name: "صندوق المركز الطبي", id: 14 },
      { name: "صندوق اقساط المرحلة الاولى", id: 15 },
      { name: "صندوق هويات المرحلة الاولى", id: 16 },
      { name: "صندوق خدمات المرحلة الاولى", id: 18 },
      { name: "صندوق التأييدات", id: 4 },
      { name: "صندوق طب الاسنان", id: 21 },
      { name: "صندوق التعليم المستمر", id: 22 },
      { name: "صندوق الرواتب", id: 25 },
      { name: "صندوق دفعة اولى ٢٠٢٦-٢٠٢٧", id: 26 },
    ],
    studentRequiredFormRules: [(v) => !!v || "حقل مطلوب . يرجى ادخال قيمة"],
    studentName: "",
    collegeNumber: "",
    overlay: false,
    levels: [
      { levelName: "المرحلة الاولى", level: 1 },
      { levelName: "المرحلة الثانية", level: 2 },
      { levelName: "المرحلة الثالثة", level: 3 },
      { levelName: "المرحلة الرابعة", level: 4 },
      { levelName: "المرحلة الخامسة", level: 5 },
    ],
    level: "",
    dates: [],
  }),
  created() {
    if (this.$store.state.userData.idEmployee == 223) {
      this.reportType = [{ name: "ايرادات", id: 1 }];
    }
  },
  methods: {
    searchData() {
      let self = this;
      self.overlay = true;
      if (self.typeId == 1 && self.dates.length > 0) {
        let query = "";

        if (self.receiptBoxId && self.receiptBoxId != 999) {
          query = `&boxId=${self.receiptBoxId}`;
        }
        if (self.receiptTypeId != "") {
          query += `&receiptTypeId=${self.receiptTypeId}`;
        }

        console.log(self.receiptBoxId);
        self.$http
          .get(`${self.$store.state.apiUrlFees}/receiptsSearch?dates=${JSON.stringify(self.dates)}${query}`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          })
          .then((res) => {
            self.overlay = false;
            console.log(res.data);
            let reportData = {
              data: res.data,
              type: self.typeId,
              dates: self.dates,
              headers: this.getHeaders(self.typeId),
            };
            this.$emit("clicked", reportData);
          })
          .catch((e) => {
            console.log(e);
            self.overlay = false;
          });
        this.searchDialog = false;
      } else if (self.typeId == 2 && self.dates.length > 0) {
        let query = "";

        if (self.expensesTypeId) {
          query += `&expensesTypeId=${self.expensesTypeId}`;
        }
        if (self.boxId) {
          query += `&boxId=${self.boxId}`;
        }

        if (self.content) {
          query += `&content=${self.content}`;
        }

        self.$http
          .get(`${self.$store.state.apiUrlFees}/expensesSearch?dates=${JSON.stringify(self.dates)}${query}`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          })
          .then((res) => {
            self.overlay = false;
            console.log(res.data);
            let reportData = {
              data: res.data,
              type: self.typeId,
              dates: self.dates,
              headers: this.getHeaders(self.typeId),
            };
            this.$emit("clicked", reportData);
          })
          .catch((e) => {
            console.log(e);
            self.overlay = false;
          });
        this.searchDialog = false;
      } else if (self.typeId == 3 && self.dates.length > 0) {
        self.$http
          .all([
            self.$http.get(`${self.$store.state.apiUrlFees}/receiptsSearch?dates=${JSON.stringify(self.dates)}`, {
              headers: { Authorization: `Bearer ${self.$store.state.user}` },
            }),
            self.$http.get(`${self.$store.state.apiUrlFees}/expensesSearch?dates=${JSON.stringify(self.dates)}`, {
              headers: { Authorization: `Bearer ${self.$store.state.user}` },
            }),
          ])
          .then(
            self.$http.spread((receipt, expenses) => {
              let expensesData = expenses.data;
              let receiptData = receipt.data;
              let receiptFiltered = receiptData.filter(
                (item) =>
                  item.boxId != 2 &&
                  item.boxId != 5 &&
                  item.boxId != 7 &&
                  item.boxId != 9 &&
                  item.boxId != 15 &&
                  item.boxId != 16 &&
                  item.boxId != 18 &&
                  item.boxId != 4 &&
                  item.boxId != 22 &&
                  item.boxId != 25,
              );
              let expensesFiltered = expensesData.filter(
                (item) =>
                  item.boxId != 2 &&
                  item.boxId != 5 &&
                  item.boxId != 7 &&
                  item.boxId != 9 &&
                  item.boxId != 15 &&
                  item.boxId != 16 &&
                  item.boxId != 18 &&
                  item.boxId != 4 &&
                  item.boxId != 22 &&
                  item.boxId != 25,
              );

              let totalExpenses = expensesFiltered.reduce((n, { amount }) => n + amount, 0);
              let totalReceipt = receiptFiltered.reduce((n, { amount }) => n + amount, 0);

              let reportData = {
                data: expensesData,
                expenses: expensesFiltered,
                receipt: receiptFiltered,
                totalExpenses: totalExpenses,
                totalReceipt: totalReceipt,
                type: self.typeId,
                dates: self.dates,
              };
              this.$emit("clicked", reportData);
              self.overlay = false;
            }),
          )
          .catch((e) => {
            console.log(e);
            self.overlay = false;
            this.$toasted.error("حدث خطأ الرجاء التأكد من الاتصال بالانترنت");
          });
        this.searchDialog = false;
      } else if (self.typeId == 4 && self.dates.length > 0) {
        self.$http
          .all([
            self.$http.get(`${self.$store.state.apiUrlFees}/receiptsSearch?dates=${JSON.stringify(self.dates)}`, {
              headers: { Authorization: `Bearer ${self.$store.state.user}` },
            }),
            self.$http.get(`${self.$store.state.apiUrlFees}/expensesSearch?dates=${JSON.stringify(self.dates)}`, {
              headers: { Authorization: `Bearer ${self.$store.state.user}` },
            }),
          ])
          .then(
            self.$http.spread((receipt, expenses) => {
              let expensesData = expenses.data;
              let receiptData = receipt.data;
              let receiptFiltered = receiptData.filter((item) => item.boxId == 15 && item.boxId != 22);
              let expensesFiltered = expensesData.filter((item) => item.boxId == 15 && item.boxId != 22);

              let totalExpenses = expensesFiltered.reduce((n, { amount }) => n + amount, 0);
              let totalReceipt = receiptFiltered.reduce((n, { amount }) => n + amount, 0);

              let reportData = {
                data: expensesData,
                expenses: expensesFiltered,
                receipt: receiptFiltered,
                totalExpenses: totalExpenses,
                totalReceipt: totalReceipt,
                type: self.typeId,
                dates: self.dates,
              };
              this.$emit("clicked", reportData);
              self.overlay = false;
            }),
          )
          .catch((e) => {
            console.log(e);
            self.overlay = false;
            this.$toasted.error("حدث خطأ الرجاء التأكد من الاتصال بالانترنت");
          });
        this.searchDialog = false;
      } else if (self.typeId == 5 && self.dates.length > 0) {
        self.$http
          .all([
            self.$http.get(`${self.$store.state.apiUrlFees}/receiptsSearch?dates=${JSON.stringify(self.dates)}`, {
              headers: { Authorization: `Bearer ${self.$store.state.user}` },
            }),
            self.$http.get(`${self.$store.state.apiUrlFees}/expensesSearch?dates=${JSON.stringify(self.dates)}`, {
              headers: { Authorization: `Bearer ${self.$store.state.user}` },
            }),
          ])
          .then(
            self.$http.spread((receipt, expenses) => {
              let expensesData = expenses.data;
              let receiptData = receipt.data;
              let receiptFiltered = receiptData.filter((item) => item.boxId == 4 && item.boxId != 22);
              let expensesFiltered = expensesData.filter((item) => item.boxId == 4 && item.boxId != 22);

              let totalExpenses = expensesFiltered.reduce((n, { amount }) => n + amount, 0);
              let totalReceipt = receiptFiltered.reduce((n, { amount }) => n + amount, 0);

              let reportData = {
                data: expensesData,
                expenses: expensesFiltered,
                receipt: receiptFiltered,
                totalExpenses: totalExpenses,
                totalReceipt: totalReceipt,
                type: self.typeId,
                dates: self.dates,
              };
              this.$emit("clicked", reportData);
              self.overlay = false;
            }),
          )
          .catch((e) => {
            console.log(e);
            self.overlay = false;
            this.$toasted.error("حدث خطأ الرجاء التأكد من الاتصال بالانترنت");
          });
        this.searchDialog = false;
      } else if (self.typeId == 6 && self.dates.length > 0) {
        self.$http
          .all([
            self.$http.get(`${self.$store.state.apiUrlFees}/receiptsSearch?dates=${JSON.stringify(self.dates)}`, {
              headers: { Authorization: `Bearer ${self.$store.state.user}` },
            }),
            self.$http.get(`${self.$store.state.apiUrlFees}/expensesSearch?dates=${JSON.stringify(self.dates)}`, {
              headers: { Authorization: `Bearer ${self.$store.state.user}` },
            }),
          ])
          .then(
            self.$http.spread((receipt, expenses) => {
              let expensesData = expenses.data;
              let receiptData = receipt.data;
              let receiptFiltered = receiptData.filter((item) => item.boxId == 22);
              let expensesFiltered = expensesData.filter((item) => item.boxId == 22);

              let totalExpenses = expensesFiltered.reduce((n, { amount }) => n + amount, 0);
              let totalReceipt = receiptFiltered.reduce((n, { amount }) => n + amount, 0);

              let reportData = {
                data: expensesData,
                expenses: expensesFiltered,
                receipt: receiptFiltered,
                totalExpenses: totalExpenses,
                totalReceipt: totalReceipt,
                type: self.typeId,
                dates: self.dates,
              };
              this.$emit("clicked", reportData);
              self.overlay = false;
            }),
          )
          .catch((e) => {
            console.log(e);
            self.overlay = false;
            this.$toasted.error("حدث خطأ الرجاء التأكد من الاتصال بالانترنت");
          });
        this.searchDialog = false;
      } else if (self.typeId == 7 && self.dates.length > 0) {
        self.$http
          .all([
            self.$http.get(`${self.$store.state.apiUrlFees}/receiptsSearch?dates=${JSON.stringify(self.dates)}&boxId=25`, {
              headers: { Authorization: `Bearer ${self.$store.state.user}` },
            }),
            self.$http.get(`${self.$store.state.apiUrlFees}/expensesSearch?dates=${JSON.stringify(self.dates)}&boxId=25`, {
              headers: { Authorization: `Bearer ${self.$store.state.user}` },
            }),
          ])
          .then(
            self.$http.spread((receipt, expenses) => {
              let expensesData = expenses.data;
              let receiptData = receipt.data;
              let receiptFiltered = receiptData.filter((item) => item.boxId == 25);
              let expensesFiltered = expensesData.filter((item) => item.boxId == 25);

              let totalExpenses = expensesFiltered.reduce((n, { amount }) => n + amount, 0);
              let totalReceipt = receiptFiltered.reduce((n, { amount }) => n + amount, 0);

              let reportData = {
                data: expensesData,
                expenses: expensesFiltered,
                receipt: receiptFiltered,
                totalExpenses: totalExpenses,
                totalReceipt: totalReceipt,
                type: self.typeId,
                dates: self.dates,
              };
              this.$emit("clicked", reportData);
              self.overlay = false;
            }),
          )
          .catch((e) => {
            console.log(e);
            self.overlay = false;
            this.$toasted.error("حدث خطأ الرجاء التأكد من الاتصال بالانترنت");
          });
        this.searchDialog = false;
      } else {
        this.$toasted.error("الرجاء اختيار المحددات");
        self.overlay = false;
      }
    },
    getHeaders() {
      let self = this;
      if (self.typeId == 1) {
        return [
          { text: "التسلسل", value: "index" },
          { text: "رقم الوصل", value: "idReceipt" },
          { text: "تاريخ الوصل", value: "receiptDateFormat" },
          { text: "نوع السند", value: "type" },
          { text: "المبلغ", value: "amount" },
          { text: "الملاحظات", value: "notes" },
        ];
      } else if (self.typeId == 2) {
        return [
          { text: "التسلسل", value: "index" },
          { text: "رقم الوصل", value: "idExpenses" },
          { text: "تاريخ الوصل", value: "expensesDateFormat" },
          { text: "نوع السند", value: "typeName" },
          { text: "المبلغ", value: "amount" },
          { text: "الملاحظات", value: "notes" },
          { text: "بواسطة", value: "employeeName" },
        ];
      } else {
      }
    },
    getDates() {
      this.datePickerSearchModel = false;
    },
  },
  computed: {
    dateRangeText() {
      return this.dates.length > 0 ? this.dates.join(" - ") : "تاريخ من - الى";
    },
  },
};
</script>

<style lang="scss" scoped></style>
